import { FormatMessageType } from '@hooks/useValidation';
import { aeroscopeSchemaValidation, holodroneSchemaValidation } from '@validations/sensors';
import { ObjectSchema } from 'yup';

import { SensorConfigurationByType } from '@/types/sensor/configuration.types';
import { EditableType } from '@/types/sensor/sensorInstallation.types';
import { SensorTypeEnum } from '@/types/sensor/sensors';

import { Step } from './SensorEditingContext';
import { aeroscopeSteps, holodroneSteps } from './sensors';

type SensorFormSteps = {
  [K in EditableType]: Step<K>[];
};

export const SensorFormStepsByType: SensorFormSteps = {
  [SensorTypeEnum.ADSB]: [],
  [SensorTypeEnum.AEROSCOPE]: aeroscopeSteps,
  [SensorTypeEnum.ARDRONIS]: [],
  [SensorTypeEnum.AUTOMATON]: [],
  [SensorTypeEnum.AVISO]: [],
  [SensorTypeEnum.BLAST]: [],
  [SensorTypeEnum.DFB6]: [],
  [SensorTypeEnum.FLIR]: [],
  [SensorTypeEnum.GROUND_STATION]: [],
  [SensorTypeEnum.HOLODRONE]: holodroneSteps,
  [SensorTypeEnum.AF2206]: [],
  [SensorTypeEnum.AXIS]: [],
  [SensorTypeEnum.MAJES]: [],
  [SensorTypeEnum.ROBIN_MAX]: [],
  [SensorTypeEnum.SENID]: [],
  [SensorTypeEnum.SKY_EYE]: [],
  [SensorTypeEnum.SKY_JACKER]: [],
  [SensorTypeEnum.SPEXER]: [],
  [SensorTypeEnum.XENTA]: [],
  [SensorTypeEnum.ZMER]: [],
  [SensorTypeEnum.GENERIC]: [],
} as const;

//TODO Remove Partial when all sensors are done
type SensorFormValidations = Partial<{
  [K in EditableType]: (formatMessage: FormatMessageType) => ObjectSchema<Partial<SensorConfigurationByType<K>>>;
}>;

export const SensorFormValidationsByType: SensorFormValidations = {
  [SensorTypeEnum.HOLODRONE]: holodroneSchemaValidation,
  [SensorTypeEnum.AEROSCOPE]: aeroscopeSchemaValidation,
};
